module.exports = __webpack_public_path__ + "static/media/screwdriver.b15b9688.svg";